module.exports = __webpack_public_path__ + "static/media/ilustrasi.4ce04287.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/ilustrasi.svg
// module id = 21
// module chunks = 1